import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import axios from "axios";
import { baseURL } from "../Data/api";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import loaderAnimation from '../assets/images/loader (2).json'; 
import Lottie from 'lottie-react';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie'
import './styles.css';
import * as XLSX from "xlsx"

const AcquiredPaidSubscribedd = () => {
    const [drawWinner, setDrawWinner] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [rows, setRows] = useState(25);
    const [serviceName, setServiceName] = useState('MyKidzHub');
    const [servicePack, setServicePack] = useState('');
    const [mode,setMode]=useState('')
    const [currency,setCurrency] = useState('')
    console.log(currency,"====")
console.log(mode,"===mode")
    // console.log(servicePack,"==servicepack")
    // console.log(serviceName,"===serviceName---")
    // const servicePacks = {
    //     MyKidzHub: ['LKIDS_M', 'LKIDS_W','LKIDS_D'],
    //     YoGamezPro: ['BIGCASH_D', 'BIGCASH_M', 'BIGCASH_W'],
    //     YoNumbers: ['LGAMING_W', 'LGAMING_D', 'LGAMING_M']
    // };

    const servicePacks = {
        MyKidzHub: [
            { value: 'LKIDS_M', label: 'Monthly' },
            { value: 'LKIDS_W', label: 'Weekly' },
            { value: 'LKIDS_D', label: 'Daily' }
        ],
        YoGamezPro: [
            { value: 'BIGCASH_D', label: 'Daily' },
            { value: 'BIGCASH_M', label: 'Monthly' },
            { value: 'BIGCASH_W', label: 'Weekly' }
        ],
        YoNumbers: [
            { value: 'LGAMING_W', label: 'Weekly' },
            { value: 'LGAMING_D', label: 'Daily' },
            { value: 'LGAMING_M', label: 'Monthly' }
        ]
    };
    

    const navigate = useNavigate();
    const username = Cookies.get('username');

    const checkuser = () => {
        if (!username || username == null || username == undefined) {
            navigate('/login');
        }
    };

    useEffect(() => {
        checkuser();
    }, []);

    const fetchData = async () => {
        if (!startDate || !endDate || !serviceName || !servicePack || !mode) {
            alert("Please select all fields");
            return;
        }

        setLoading(true);
        setSubmitted(true);
        try {
            const response = await axios.get(`${baseURL}/api/v1/period/paidsubscribed`, {
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    serviceName: serviceName,
                    pack: servicePack,
                    mode:mode,
                    currency:currency
                },
            });

            console.log('gamedetails API Response Data:', response);
            console.log('gamedetails API Response Status:', response.status);

            setDrawWinner(response.data);
            console.log('Updated drawWinner state:', response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fetchData();
    };

    const formatDate = (date, isEndDate = false) => {
        if (!date) return '';
        const time = isEndDate ? '23:59:59' : '00:00:00';
        const formatted = dayjs(date).format('YYYY-MM-DD') + ` ${time}`;
        console.log('Formatted Date:', formatted);
        return formatted;
    };

    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(drawWinner);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "AcquiredPaidSubscribe");
        XLSX.writeFile(workbook, "AcquiredPaidSubscribe.xlsx");
    };

    return (
        <Layout>
            <div className="">
                <div className="flex justify-between">
                    <span className="font-semibold text-lg text-black">AcquiredPaidSubscribed Details</span>
                </div>
            </div>

            <div className="flex justify-center items-center mt-3 text-black">
    <form onSubmit={handleSubmit} className="flex flex-col gap-6 bg-gray-100 p-4 rounded-lg shadow-lg w-full max-w-5xl">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="flex flex-col lg:flex-row gap-2 w-full">

                <div className="w-full">
                    <label>Service</label>
                    <select
                        value={serviceName}
                        onChange={(e) => {
                            setServiceName(e.target.value);
                        }}
                        className="w-full py-4 border-zinc-400 hover:border-black rounded bg-gray-50 border">
                        <option value="MyKidzHub">MyKidzHub</option>
                        <option value="YoGamezPro">YoGamezPro</option>
                        <option value="YoNumbers">YoNumbers</option>
                    </select>
                </div>

                <div className="w-full">
                    <label>Pack</label>
                    <select
                        value={servicePack}
                        onChange={(e) => setServicePack(e.target.value)}
                        className="w-full py-4 border-zinc-400 hover:border-black rounded bg-gray-50 border">
                        <option value="">Select Pack</option>
                        {servicePacks[serviceName]?.map((pack) => (
                            <option key={pack.value} value={pack.value}>
                                {pack.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="w-full">
                    <label>Mode</label>
                    <select
                        value={mode}
                        onChange={(e) => {
                            console.log('Selected Mode:', e.target.value);
                            setMode(e.target.value);
                        }}
                        className="w-full py-4 border-zinc-400 hover:border-black rounded bg-gray-50 border">
                        <option value="">Select Mode</option>
                        <option value="USSD">USSD</option>
                        <option value="WEB">WEB</option>
                    </select>
                </div>

                <div className="w-full">
                    <label>Currency</label>
                    <select
                        value={currency}
                        onChange={(e) => {
                            console.log('Selected Mode:', e.target.value);
                            setCurrency(e.target.value);
                        }}
                        className="w-full py-4 border-zinc-400 hover:border-black rounded bg-gray-50 border">
                        <option value="">Select Mode</option>
                        <option value="USD">USD</option>
                        <option value="ZWG">ZWG</option>
                    </select>
                </div>

                <div className="w-full">
                    <label>Start Date</label>
                    <DatePicker
                        value={startDate ? dayjs(startDate) : null}
                        onChange={(newValue) => {
                            const formattedDate = formatDate(newValue);
                            console.log('Selected Start Date:', formattedDate);
                            setStartDate(formattedDate);
                        }}
                        format="YYYY-MM-DD"
                        className="w-full"
                    />
                </div>
                <div className="w-full">
                    <label>End Date</label>
                    <DatePicker
                        value={endDate ? dayjs(endDate) : null}
                        onChange={(newValue) => {
                            const formattedDate = formatDate(newValue, true);
                            console.log('Selected End Date:', formattedDate);
                            setEndDate(formattedDate);
                        }}
                        format="YYYY-MM-DD"
                        className="w-full"
                    />
                </div>
            </div>
        </LocalizationProvider>

        <div className="flex justify-center">
            <button type="submit" className="bg-blue-500 text-white p-2 rounded hover:bg-blue-400">
                Submit
            </button>
        </div>
    </form>
</div>

            {loading && <div className="flex justify-center items-center w-full mt-10 lg:mt-4">
                <Lottie animationData={loaderAnimation} style={{ width: 200, height: 200 }} />
            </div>}

            {!loading && submitted && drawWinner.length === 0 && <p className="text-center mt-10 text-red-500 ">No Data Found</p>}

            {!loading && drawWinner.length > 0 && (
                <div className="overflow-x-auto mt-10">
                    <div className="flex justify-end mb-4">
                     

                     <button onClick={downloadExcel} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-400">
                         Download
                     </button>
                 </div>
                    <TreeTable  className="w-[400px] sm:w-[660px] md:w-[790px] lg:w-[980px]"

                        value={drawWinner.map((item, index) => ({
                            key: index.toString(),
                            data: { ...item, serialNumber: index + 1 }
                        }))}
                        tableStyle={{ minWidth: "50rem" }}
                        paginator
                        rowsPerPageOptions={[25, 50,75,100]}
                        rows={rows}
                        // className="text-black "
                    >

<Column field="serialNumber" header="S.No" style={{ width: "80px" }}
                            body={(rowData) => rowData.data.serialNumber}></Column>
                        <Column field="date" header="Date" style={{ width: "120px" }}></Column>
                        <Column field="subscriptionCount" header="SubscriptionCount" style={{ width: "120px" }}></Column>
                        
                    </TreeTable>
                </div>
            )}
        </Layout>
    );
};

export default AcquiredPaidSubscribedd;